<template>
  <div class="main">
    <a-form-model @keyup.enter.native="handleSubmit" class="user-layout-login">
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick"
      >
        <a-tab-pane key="tab1" tab="账号密码登录">
          <login-account @fail="requestFailed" @success="requestSuccess" @validateFail="validateFail" ref="alogin"></login-account>
        </a-tab-pane>

        <!-- <a-tab-pane key="tab2" tab="手机号登录">
          <login-phone ref="plogin" @validateFail="validateFail" @success="requestSuccess" @fail="requestFailed"></login-phone>
        </a-tab-pane>-->
      </a-tabs>

      <a-form-model-item>
        <a-checkbox @change="handleRememberMeChange" default-checked>自动登录</a-checkbox>
        <router-link :to="{ name: 'alteration'}" class="forge-password" style="float: right;color:#fff;">忘记密码</router-link>
        <!-- <router-link :to="{ name: 'register'}" class="forge-password" style="float: right;margin-right: 10px" >
          注册账户
        </router-link>-->
      </a-form-model-item>

      <a-form-item style="margin-top:24px">
        <a-button
          :disabled="loginBtn"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          class="login-button"
          htmlType="submit"
          size="large"
          type="primary"
        >确定</a-button>
      </a-form-item>
    </a-form-model>

    <two-step-captcha
      :visible="stepCaptchaVisible"
      @cancel="stepCaptchaCancel"
      @success="stepCaptchaSuccess"
      v-if="requiredTwoStepCaptcha"
    ></two-step-captcha>
    <login-select-tenant @success="loginSelectOk" ref="loginSelect"></login-select-tenant>
    <!-- <third-login ref="thirdLogin"></third-login> -->

    <safe-tips @cancel="safeTipsReject" @ok="safeTipsAgree" ref="safeTips"></safe-tips>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
  import ThirdLogin from './third/ThirdLogin'
  import LoginSelectTenant from './LoginSelectTenant'
  import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
  import { getEncryptedString } from '@/utils/encryption/aesEncrypt'
  import { timeFix } from '@/utils/util'
  import { agreeSafeTips } from '@/api/api'

  import LoginAccount from './LoginAccount'
  import LoginPhone from './LoginPhone'
  import SafeTips from './SafeTips'

  export default {
    components: {
      LoginSelectTenant,
      TwoStepCaptcha,
      ThirdLogin,
      LoginAccount,
      LoginPhone,
      SafeTips
    },
    data () {
      return {
        customActiveKey: 'tab1',
        rememberMe: true,
        loginBtn: false,
        requiredTwoStepCaptcha: false,
        stepCaptchaVisible: false,
        encryptedString: {
          key: '',
          iv: ''
        }
      }
    },
    created () {
      Vue.ls.remove(ACCESS_TOKEN)
      this.getRouterData()
      this.rememberMe = true
    },

    methods: {
      ...mapActions(['Logout']),
      handleTabClick (key) {
        this.customActiveKey = key
      },
      handleRememberMeChange (e) {
        this.rememberMe = e.target.checked
      },
      /** 跳转到登录页面的参数-账号获取 */
      getRouterData () {
        this.$nextTick(() => {
          let temp = this.$route.params.username || this.$route.query.username || ''
          if (temp) {
            this.$refs.alogin.acceptUsername(temp)
          }
        })
      },

      // 登录
      handleSubmit () {
        this.loginBtn = true
        if (this.customActiveKey === 'tab1') {
          // 使用账户密码登录
          this.$refs.alogin.handleLogin(this.rememberMe)
        } else {
          // 手机号码登录
          this.$refs.plogin.handleLogin(this.rememberMe)
        }
      },
      // 校验失败
      validateFail () {
        this.loginBtn = false
      },
      // 登录后台成功
      requestSuccess (loginResult) {
        this.loginResult = loginResult;
        this.$refs.loginSelect.show(loginResult)
      },
      // 登录后台失败
      requestFailed (err) {
        let description = ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试'
        this.$notification['error']({
          message: '登录失败',
          description: description,
          duration: 4
        })

        this.loginBtn = false
      },
      loginSelectOk () {
        this.loginSuccess()
      },
      // 登录成功
      /**
       * @date 2024-09-28 登录成功后，如果用户首次登录（之前未同意安全协议），则弹出面板。
       */
      loginSuccess () {
        if (this.loginResult.userInfo.safeAgreeTime) {
          this.safeTipsAgree()
        } else {
          this.$refs.safeTips.show(this.loginResult.userInfo);
        }
      },
      //同意安全协议
      safeTipsAgree () {
        agreeSafeTips({});

        this.$store.commit('SET_ROUTERS', [])
        this.$router.push({ path: '/' })
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      },
      //不同意安全协议，强制退出登录
      safeTipsReject () {
        this.Logout({}).finally(() => {
          this.loginBtn = false
        });
      },
      stepCaptchaSuccess () {
        this.loginSuccess()
      },
      stepCaptchaCancel () {
        this.Logout().then(() => {
          this.loginBtn = false
          this.stepCaptchaVisible = false
        })
      },
      // 获取密码加密规则
      getEncrypte () {
        var encryptedString = Vue.ls.get(ENCRYPTED_STRING)
        if (encryptedString == null) {
          getEncryptedString().then((data) => {
            this.encryptedString = data
          })
        } else {
          this.encryptedString = encryptedString
        }
      }

    }

  }
</script>
<style lang="less" scoped>
  .user-layout-login {
    label {
      font-size: 14px;
      color: #f0f2f5;
    }
    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .forge-password {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .item-icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }

      .register {
        float: right;
      }
    }
  }
</style>
<style>

  .valid-error .ant-select-selection__placeholder {
    color: #f5222d;
  }

</style>
